import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./utils/reportWebVitals";
import "./fonts/fonts.css";
import "./styling.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
